<template>
    <div>
      <!-- NAVBAR -->
      <my-navbar :controller="controller" />

      <!-- HEADER -->
      <div class="header bg-gradient-dark pb-8 pt-5 pt-md-8 hide">
        <div class="container-fluid">
          <div class="header-body">
            <div class="row">
              <!-- CONTENIDO HEADER -->
            </div>
          </div>
        </div>
      </div>

      <!-- CONTENT -->
      <div class="container-fluid mt--7">
        <div class="row">
          <div class="col">
            <!-- COMPONENTE PRINCIPAL -->
            <div class="row">
              <div class="col-lg-12">

                  <div class="ui-sys-msg">
                      <div class="ui-sys-icon info">
                          <i class="fa fa-info-circle"></i>
                      </div>
                      <h3 class="ui-sys-title">Error 404</h3>
                      <p class="ui-sys-text">La página que intenta acceder no existe o fue eliminada.</p>
                  </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
</template>
<script>
  export default {
    name: "p404",
    data() {
      return {
        controller: {
          title: "Página no encontrada",
          mainRouter: "/"      
        }
      };
    }
  };
</script>